module.exports = __webpack_public_path__ + "img/orange-and-red-lily.5d1a4c40.webp";